/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Outcome_Select_LabelInputs */

const en_task_outcome_select_label = /** @type {(inputs: Task_Outcome_Select_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solution`)
};

const pt_br2_task_outcome_select_label = /** @type {(inputs: Task_Outcome_Select_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solução`)
};

/**
* | output |
* | --- |
* | "Solution" |
*
* @param {Task_Outcome_Select_LabelInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_outcome_select_label = /** @type {((inputs?: Task_Outcome_Select_LabelInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Outcome_Select_LabelInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_outcome_select_label(inputs)
	return pt_br2_task_outcome_select_label(inputs)
});